var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import warning from "./warning";

var bindStateToSelector = function bindStateToSelector(prevKey, selector) {
  return function (state) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var targetState = prevKey ? state[prevKey] : state;
    return selector.apply(undefined, [targetState].concat(args));
  };
};

var __combineSelectors = function __combineSelectors(selectors) {
  var prevKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return Object.keys(selectors).reduce(function (finalSelectors, selectorKey) {
    var selector = selectors[selectorKey];

    if (process.env.NODE_ENV !== "production") {
      if (typeof selector === "undefined") {
        warning("No selector provided for key \"" + selectorKey + "\"");
      }
    }

    if (typeof selector === "function") {
      return _extends({}, finalSelectors, _defineProperty({}, selectorKey, bindStateToSelector(prevKey, selector)));
    } else {
      return _extends({}, finalSelectors, _defineProperty({}, selectorKey, __combineSelectors(selector, prevKey || selectorKey)));
    }
  }, {});
};

export var combineSelectors = function combineSelectors(modules) {
  return __combineSelectors(modules);
};